module.exports = __webpack_public_path__ + "img/info-circle.ce66f673.svg";